import React from 'react';
import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import { mediumOrange } from 'constants/blogColors';

type Props = {
  quote: string;
  quoteBy: string | null;
};

export const PullQuote = (props: Props) => {
  const { quote, quoteBy } = props;
  return (
    <Outer>
      <ContentWrapper>
        <QuoteIcon viewBox={'0 0 40 30'}>
          <path
            d="M37.7562 0V2.2006C34.587 3.33833 32.1035 5.13473 30.3055 7.58982C28.5076 10.015 27.6087 12.5449 27.6087 15.1796C27.6087 15.7485 27.7001 16.1677 27.8829 16.4371C28.0048 16.6168 28.1419 16.7066 28.2943 16.7066C28.4467 16.7066 28.6752 16.6018 28.98 16.3922C29.9551 15.7036 31.1893 15.3593 32.6824 15.3593C34.4194 15.3593 35.9583 16.0629 37.2991 17.4701C38.6399 18.8473 39.3103 20.494 39.3103 22.4102C39.3103 24.4162 38.5333 26.1826 36.9792 27.7096C35.4555 29.2365 33.5966 30 31.4026 30C28.8428 30 26.6335 28.9671 24.7747 26.9012C22.9158 24.8353 21.9864 22.0659 21.9864 18.5928C21.9864 14.5509 23.251 10.9281 25.7803 7.72455C28.3095 4.52096 32.3015 1.94611 37.7562 0ZM15.7698 0V2.2006C12.6006 3.33833 10.1171 5.13473 8.31917 7.58982C6.52125 10.015 5.62229 12.5449 5.62229 15.1796C5.62229 15.7485 5.71371 16.1677 5.89655 16.4371C6.01844 16.6168 6.15557 16.7066 6.30794 16.7066C6.46031 16.7066 6.68885 16.6018 6.99359 16.3922C7.96873 15.7036 9.20289 15.3593 10.6961 15.3593C12.433 15.3593 13.9719 16.0629 15.3128 17.4701C16.6536 18.8473 17.324 20.494 17.324 22.4102C17.324 24.4162 16.5469 26.1826 14.9928 27.7096C13.4691 29.2365 11.6103 30 9.4162 30C6.85646 30 4.64715 28.9671 2.78829 26.9012C0.929431 24.8353 0 22.0659 0 18.5928C0 14.5509 1.26464 10.9281 3.79391 7.72455C6.32318 4.52096 10.3152 1.94611 15.7698 0Z"
            fill="#FF9266"
          />
        </QuoteIcon>
        <Quote>{quote}</Quote>
        {quoteBy?.length ? <QuoteBy>{props.quoteBy}</QuoteBy> : null}
      </ContentWrapper>
    </Outer>
  );
};

const Outer = styled.div`
  display: grid;
  justify-content: center;
  place-items: center;
`;

const ContentWrapper = styled.div`
  display: grid;
  grid-row-gap: 20px;
  justify-items: center;
  padding: 0 20px;
  max-width: 600px;
  text-align: center;
  ${mediaQueries.tablet} {
    grid-row-gap: 25px;
  }
`;

const QuoteIcon = styled.svg`
  width: 26px;
  height: 20px;
  fill: none;
  ${mediaQueries.tablet} {
    width: 40px;
    height: 30px;
  }
`;

const Quote = styled.blockquote`
  color: ${Colors.grey900};
  font-size: 23px;
  line-height: 140%;
  text-align: center;
  ${mediaQueries.tablet} {
    font-size: 27px;
  }
`;

const QuoteBy = styled.p`
  color: ${mediumOrange};
  font-weight: 800;
  font-size: 13px;
  line-height: 150%;
  text-align: center;
`;
